import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { FaUpload, FaTimes } from 'react-icons/fa';
import VendorHeader from './vendorHeader';
import './businessProfile.css';
import VendorSidebar from './VendorSidebar';
import Navbar from '../components/navbar';

const UpdateProfileVendor = () => {
  const { vendorId } = useParams();
  const navigate = useNavigate();

  const [vendorData, setVendorData] = useState({
    websiteDisplayName: '',
    
    companyDescription: '',
    businessName: '',
    OfficeContact: '',
    FaxNumber: '',
    Ownership: '',
    logo: '',
    AnnualTakeover: '',
    establishment: '',
    NoEmployee: '',
    selectType: '',
    Address: '',
    City: '',
    State: '',
    Country: '',
    Pincode: '',
    businessDetails: [],
  });

  const [images, setImages] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [logoFile, setLogoFile] = useState(null);
  const [error, setError] = useState(null);
  const [activeSubMenu, setActiveSubMenu] = useState(null);
  const [businessType, setBusinessType] = useState(null);
  const [profileCompleteness, setProfileCompleteness] = useState(0);
  const [showCompanyDetails, setShowCompanyDetails] = useState(true);
  const [showAddressDetails, setShowAddressDetails] = useState(false);
  const [activeSection, setActiveSection] = useState('basic');

  const businessDetailsOptions = [
    "Agent", "Buying Office", "Consultant", "Distributor", "Domestic Seller",
    "Exporter", "Importer", "Manufacturer", "Online Seller", "Retailer",
    "Trading Company", "Wholesaler", "Other", "Fabricator"
  ];

  const toggleCompanyDetails = () => setShowCompanyDetails(!showCompanyDetails);
  const toggleAddressDetails = () => setShowAddressDetails(!showAddressDetails);

  useEffect(() => {
    const handleScroll = () => {
      const basic = document.getElementById('basic-section');
      const business = document.getElementById('business-section');
      const address = document.getElementById('address-section');
      const scrollPosition = window.scrollY + 250;

      if (address && address.offsetTop <= scrollPosition) {
        setActiveSection('address');
      } else if (business && business.offsetTop <= scrollPosition) {
        setActiveSection('business');
      } else if (basic && basic.offsetTop <= scrollPosition) {
        setActiveSection('basic');
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleCheckboxChange = (option) => {
    const current = Array.isArray(vendorData.businessDetails) ? vendorData.businessDetails : [];
    let updated = [];

    if (current.includes(option)) {
      updated = current.filter(item => item !== option);
    } else {
      updated = [...current, option];
    }

    setVendorData(prev => ({ ...prev, businessDetails: updated }));
  };

  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
      if (!allowedTypes.includes(file.type)) {
        setError('Please upload only PNG, JPG, or GIF files');
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        setError('File size should be less than 10MB');
        return;
      }

      setLogoFile(file);
      const reader = new FileReader();
      reader.onload = (e) => {
        setVendorData(prev => ({ ...prev, logo: e.target.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    const remainingSlots = 10 - images.length;
    const filesToProcess = files.slice(0, remainingSlots);

    filesToProcess.forEach(file => {
      const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
      if (!allowedTypes.includes(file.type)) {
        setError('Please upload only PNG, JPG, or GIF files');
        return;
      }

      if (file.size > 10 * 1024 * 1024) {
        setError('File size should be less than 10MB');
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        setImages(prev => [...prev, file]);
        setImagePreviews(prev => [...prev, e.target.result]);
      };
      reader.readAsDataURL(file);
    });
  };

  const removeImage = (index) => {
    setImages(prev => prev.filter((_, i) => i !== index));
    setImagePreviews(prev => prev.filter((_, i) => i !== index));
  };

  useEffect(() => {
    const vendortoken = localStorage.getItem('vendortoken');
    if (!vendortoken) return setError('No token found');

    axios.post(`${process.env.REACT_APP_API_URL}/vendorData`, { vendortoken })
      .then(response => {
        if (response.data.status === 'ok') {
          const data = response.data.data;
          setVendorData(prev => ({
            ...prev,
            ...data,
            businessDetails: Array.isArray(data.businessDetails) ? data.businessDetails : []
          }));
          setBusinessType(data.businessType);
          if (data.logo) setImagePreviews([data.logo]);
        } else {
          setError(response.data.message);
        }
      })
      .catch(error => {
        console.error('Error:', error);
        setError(error.message);
      });
  }, [vendorId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setVendorData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const vendortoken = localStorage.getItem('vendortoken');

    try {
      const formData = new FormData();
      Object.keys(vendorData).forEach(key => {
        formData.append(key, key === 'businessDetails'
          ? JSON.stringify(vendorData[key])
          : vendorData[key]);
      });

      if (logoFile) formData.append('logo', logoFile);
      images.forEach((img, idx) => formData.append(`image_${idx}`, img));

      const response = await axios.put(`${process.env.REACT_APP_API_URL}/BusinessProfile`, formData, {
        headers: {
          'Authorization': `Bearer ${vendortoken}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.data.status === 'ok') {
        navigate('/');
      } else {
        setError(response.data.message);
      }
    } catch (err) {
      setError(err.message);
      console.error('Submit error:', err);
    }
  };

  return (
    <div>
      <Navbar />
      <div className='main-container-businessDetails'>
        <VendorSidebar />
        <form onSubmit={handleSubmit} className='formbusiness'>
          <div className='info-layout'>
            {error && <p className="error">{error}</p>}
            <div className='business-sidecontent'>
              <div className='business-container-box'>
                <div className='userinfo-container' id="basic-section">
                  <div className='basic-content'>
                    <h3>Basic Company Information</h3>
                  </div>

                  <div className="form-container1">
                      <div className="input-container-box">
                      <div className="labelcontainer">
                        <label htmlFor="businessName">Company Name:</label>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        id="businessName"
                        name="businessName"
                        placeholder='Enter Company Name'
                        value={vendorData.businessName}
                        onChange={handleChange}
                        readOnly
                      />
                    </div>


                    <div className="input-container-box">
                      <div className="labelcontainer"><label>Company Logo</label></div>
                      <div className="image-upload-area">
                       {vendorData.logo ? (
  <div className="image-preview-card" style={{ height: "150px" }}>
    <img src={`${process.env.REACT_APP_API_URL}/${vendorData.logo}`} alt="logo" />
    <button
      type="button"
      onClick={() => setVendorData(prev => ({ ...prev, logo: '' }))}
      className="remove-image-btn"
    >
      <FaTimes />
    </button>
  </div>
): (
                          <div className="upload-placeholder" style={{height:"150px"}}>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={handleLogoUpload}
                              className="hidden-file-input"
                              id="logo-upload"
                            />
                            <label htmlFor="logo-upload" className="upload-label">
                              <FaUpload /> Upload Logo <small>(Max 10MB)</small>
                            </label>
                          </div>
                        )}
                      </div>
                    </div>

                      
                    <div className="input-container-box">
                      <div className="labelcontainer">
                        <label htmlFor="websiteDisplayName">Website Display Name</label>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        name="websiteDisplayName"
                        value={vendorData.websiteDisplayName}
                        onChange={handleChange}
                      />
                    </div>
                    
                    <div className="input-container-box">
                      <div className="labelcontainer"><label>Business Type</label></div>
                      <div className="form-group-businessdetails">
                        {businessDetailsOptions.map((option) => (
                          <div className="form-check col-sm-2" key={option}>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value={option}
                              checked={Array.isArray(vendorData.businessDetails) && vendorData.businessDetails.includes(option)}
                              onChange={() => handleCheckboxChange(option)}
                              id={`check-${option}`}
                            />
                            <label className="form-check-label" htmlFor={`check-${option}`}>
                              {option}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="input-container-box">
                      <div className="labelcontainer"><label>Company Description</label></div>
                      <textarea
                        className="form-control"
                        name="companyDescription"
                        value={vendorData.companyDescription}
                        onChange={handleChange}
                        rows="5"
                      />
                    </div>
                  </div>
                </div>

                {/* Business Profile Section */}
                <div className='userinfo-container' id="business-section">
                  <div className='basic-content'>
                    <h3>Business Profile</h3>
                  </div>

                  <div className="form-container1">
                  
                    <div className="input-container-box">
                      <div className="labelcontainer">
                        <label htmlFor="OfficeContact">Office Contact Number:</label>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        id="OfficeContact"
                        name="OfficeContact"
                        placeholder='Office Contact Number'
                        value={vendorData.OfficeContact}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="input-container-box">
                      <div className="labelcontainer">
                        <label htmlFor="FaxNumber">Fax Number:</label>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        id="FaxNumber"
                        name="FaxNumber"
                        placeholder='Fax Number'
                        value={vendorData.FaxNumber}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="input-container-box">
                      <div className="labelcontainer">
                        <label htmlFor="Ownership">Ownership Type:</label>
                      </div>
                      <select
                        className="form-control"
                        id="Ownership"
                        name="Ownership"
                        value={vendorData.Ownership}
                        onChange={handleChange}
                        required
                      >
                        <option>Ownership Type</option>
                        <option>Public Limited Company</option>
                        <option>Private Limited Company</option>
                        <option>Partnership</option>
                        <option>Proprietorship</option>
                        <option>Professional Associations</option>
                        <option>Others</option>
                      </select>
                    </div>

                    <div className="input-container-box">
                      <div className="labelcontainer">
                        <label htmlFor="AnnualTakeover">Annual Takeover</label>
                      </div>
                      <input
                        type="tel"
                        className="form-control"
                        id="AnnualTakeover"
                        name="AnnualTakeover"
                        placeholder='Annual Takeover'
                        value={vendorData.AnnualTakeover}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="input-container-box">
                      <div className="labelcontainer">
                        <label htmlFor="establishment">Year of Establishment:</label>
                      </div>
                      <input
                        type="tel"
                        className="form-control"
                        id="establishment"
                        name="establishment"
                        placeholder='Year of Establishment'
                        value={vendorData.establishment}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="input-container-box">
                      <div className="labelcontainer">
                        <label htmlFor="NoEmployee">Number of Employees:</label>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        id="NoEmployee"
                        name="NoEmployee"
                        placeholder='Number of Employees'
                        value={vendorData.NoEmployee}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="input-container-box">
                      <div className="labelcontainer mb-3">
                        <label htmlFor="selectType">Select Type:</label>
                      </div>
                      <select
                        className="form-control"
                        id="selectType"
                        name="selectType"
                        value={vendorData.selectType}
                        onChange={handleChange}
                        required
                      >
                        <option>Service Based Company</option>
                        <option>Product Based Company</option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* Address Details Section */}
                <div className='userinfo-container mb-5' id="address-section">
                  <div className='basic-content'>
                    <h3>Address Details</h3>
                  </div>

                  <div className="form-container1">
                    <div className="input-container-box">
                      <div className="labelcontainer">
                        <label htmlFor="Address">Address:</label>
                      </div>
                      <textarea
                        className="form-control"
                        id="Address"
                        name="Address"
                        placeholder="Enter Address"
                        value={vendorData.Address}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="input-container-box">
                      <div className="labelcontainer">
                        <label htmlFor="City">City:</label>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        id="City"
                        name="City"
                        placeholder='City'
                        value={vendorData.City}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="input-container-box">
                      <div className="labelcontainer">
                        <label htmlFor="State">State:</label>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        id="State"
                        name="State"
                        placeholder='State'
                        value={vendorData.State}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="input-container-box">
                      <div className="labelcontainer">
                        <label htmlFor="Pincode">Pincode:</label>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        id="Pincode"
                        name="Pincode"
                        placeholder='Pincode'
                        value={vendorData.Pincode}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="input-container-box">
                      <div className="labelcontainer">
                        <label htmlFor="Country">Country</label>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        id="Country"
                        name="Country"
                        placeholder='Country'
                        value={vendorData.Country}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className='sidecontent'>
                <div className='sidecontent-inner'>
                  <div className='ant-anchor'>
                    <div className="side-line">
                      <span className='ant-anchor-ink-ball visible'></span>
                    </div>
                    <h5 className={`sidecontent-head ${activeSection === 'basic' ? 'active' : ''}`}>Basic Info</h5>
                    <h5 className={`sidecontent-head ${activeSection === 'business' ? 'active' : ''}`}>Business Info</h5>
                    <h5 className={`sidecontent-head ${activeSection === 'address' ? 'active' : ''}`}>Address Info</h5>
                  </div>
                </div>
              </div>
            </div>

            <div className="button-container mt-3">
              <button type="submit" className="btn btn-danger">Submit</button>
              <button type="button" className="btn btn-secondary ml-2">Save Draft</button>
              <button type="button" className="btn btn-outline-secondary ml-2">Cancel</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateProfileVendor;
